import React, { useState } from "react";
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import axios from "axios";
import { baseUrl, ROUTE_BASE_URL } from "../../../api/common";
export default function ChangePassword() {

	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const changePassword = async () => {
		if (!newPassword) {
		  showToast("Pasword cannot be empty", "error");
		  return;
		}
        if (!confirmPassword) {
          showToast("Confirm password cannot be empty", "error");
          return;
        }
        if (confirmPassword !== newPassword) {
          showToast("Passwords do not match", "error");
          return false;
        }		
		try {
          const encryptData = window.location.search.substring(1);
		  const response = await axios.post(
			`${baseUrl}/api/member_forgot_pass_update`,
			{ 
				password: newPassword,
                encrypt_data:encryptData
			 },
			{
			  headers: {
				"Content-Type": "application/json",
				Authorization: localStorage.getItem("access_token"),
			  },
			}
		  );
		  if (response.data.status) {
			showToast(response.data.message, "success");
			setNewPassword("");
			setConfirmPassword("");
		  } else {
			showToast(response.data.message, "error");
		  }
		} catch (error) {
		  console.error("Error during submission:", error);
		  showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
		}
	};	

	return (
	  <>
	      <ToastMessage /> 
		  <div className="auth-main particles_js">
			  <div className="auth_div vivify popIn change-pass-width">
				  <div className="auth_brand">
					  <Link to={`${ROUTE_BASE_URL}/user-login`}>
					  <img
							src={logo}
							// src="https://cdn.prod.website-files.com/66712a83ccf4e64be43d1817/66712f8f27aaed354f88a0b7_amasi_logo.png"
							width="80"
							height="80"
							className="d-inline-block align-top mr-2"
							alt="AMASI"
						/>					  
						</Link>
				  </div>
				  <div className="card forgot-pass">
					  <div className="body">
						  <p className="lead mb-3"><strong>Create a new password!</strong></p>
						  <div className="form-group pos_relative text-left">
						  <label>
                           New password <span className="text-danger">*</span>
						  </label>
						  <input
							  type="email"
							  value={newPassword}
							  onChange={e => setNewPassword(e.target.value)}
							  className="form-control"
							  placeholder="Enter your Password"
						  />
						  </div>
                          <div className="form-group pos_relative text-left">
						  <label>
                           Confirm password <span className="text-danger">*</span>
						  </label>
						  <input
							  type="text"
							  value={confirmPassword}
							  onChange={e => setConfirmPassword(e.target.value)}
							  className="form-control"
							  placeholder="Enter your Confirm Password"
						  />
						  </div>
						  <button onClick={()=>changePassword()} className="btn btn-outline-primary btn-block">Submit</button>
					  </div>
				  </div>
			  </div>
			  <div id="particles-js"></div>
		  </div>
	  </>
  );
}
